export const GET_TAGS_BY_CAT = 'GET_TAGS_BY_CAT';
export const GET_TAGS_BY_CAT_SUCCESS = 'GET_TAGS_BY_CAT_SUCCESS';
export const GET_TAGS_BY_CAT_FAIL = 'GET_TAGS_BY_CAT_FAIL';

export const GET_TEMPLATES_BY_CAT_AND_TAG = 'GET_TEMPLATES_BY_CAT_AND_TAG';
export const GET_TEMPLATES_BY_CAT_AND_TAG_SUCCESS =
  'GET_TEMPLATES_BY_CAT_AND_TAG_SUCCESS';
export const GET_TEMPLATES_BY_CAT_AND_TAG_FAIL =
  'GET_TEMPLATES_BY_CAT_AND_TAG_FAIL';
